// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"HotServices_gridContainer__8fKkQ","row":"HotServices_row__1_iWC","col":"HotServices_col__A_w9b","link":"HotServices_link__hCEQm","title":"HotServices_title__DAARe"};